import type { FC } from "react";
import { DentalArchesSvg, getTeethNumbers, type Product } from "@jasper/shared";

type OrderSelectedProductArchesProps = {
  selectedProduct: Product | null;
};

const ARCHES_WIDTH = 275;
const ARCHES_HEIGHT = 366;

export const OrderSelectedProductArches: FC<
  OrderSelectedProductArchesProps
> = ({ selectedProduct }) => {
  if (!selectedProduct) {
    return null;
  }
  return (
    <DentalArchesSvg
      teeth={getTeethNumbers(selectedProduct)}
      width={ARCHES_WIDTH}
      height={ARCHES_HEIGHT}
    />
  );
};
